
export default "/assets/bars-arrow-down-micro.207e1f65.svg"